import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_hdr_RowClass} from '../../../dbschema/bl_wf_issue_hdr.model';

export class InquiryHeaderContainerModel extends BaseContainerModel {
  bl_wf_issue_hdr: bl_wf_issue_hdr_RowClass = new bl_wf_issue_hdr_RowClass();
}
